(function (window, document, undefined) {
  'use strict';
  var ModalAlertSrvc = function ($q) {
    this.defer;
    this.promise;

    this.modal;

    var self = this;
    this.notify = function (message) {
      self.defer.notify(message);
    };

    this.resetService = function () {
      self.defer = $q.defer();
      self.promise = self.defer.promise;
    };
  };

  ModalAlertSrvc.$inject = ['$q'];

  angular.module('cbl.finanza.mf').service('modalAlertSrvc', ModalAlertSrvc);
})(window, document);



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/modalAlert/modalAlert.srvc.js
 ** module id = 46
 ** module chunks = 1 2
 **/